module.exports = __webpack_public_path__ + "img/ONiAd-Academy-imagen-2.7b169bce.png";